import isPermissionEnabled from "common/isPermissionEnabled"

/**
 * Same wallet visibility rules as Order Details "Payments Details" card.
 * Used by UI and order-detail PDF export.
 */
export const hasWalletRelatedPermission = (
  userRole,
  accountType,
  accountScope
) => {
  if (
    isPermissionEnabled(
      userRole,
      1,
      "dashboard_8",
      accountType,
      accountScope
    ) ||
    isPermissionEnabled(
      userRole,
      46,
      "coupon_redeem_1",
      accountType,
      accountScope
    )
  ) {
    return true
  }

  const categories = userRole?.permissions || []
  const findCategory = categoryId =>
    categories.find(role => Number(role.id) === Number(categoryId))

  const hasPermission = (categoryId, permissionId) =>
    Boolean(
      findCategory(categoryId)?.permissions?.some(
        permission => permission.id === permissionId
      )
    )

  const hasSubPermission = (categoryId, permissionId, subPermissionId) => {
    const permission = findCategory(categoryId)?.permissions?.find(
      entry => entry.id === permissionId
    )
    return Boolean(
      permission?.subPermissions?.some(sub => sub.id === subPermissionId)
    )
  }

  return (
    hasPermission(1, "dashboard_8") ||
    hasPermission(46, "coupon_redeem_1") ||
    hasSubPermission(7, "customersPermission_1", "view_wallet_history") ||
    hasSubPermission(16, "report_1", "view_wallet_reports") ||
    hasSubPermission(16, "report_1", "view_wallet_transfer_reports") ||
    hasSubPermission(16, "report_1", "view_wallet_purchase_reports")
  )
}
